import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { LoaderBlock } from '../../../common/components/loaders/LoaderBlock/LoaderBlock'
import { useBusinessSettings } from '../../../contexts/BusinessSettingsContext'
import { useUser } from '../../../contexts/userContext'
import { routes } from '../../../routes'
import { dateTimeToLocalDateString } from '../../../util/string'
import styles from '../Settings.module.css'
import { Members } from './components/Members'
import { OrganizationInfo } from './components/OrganizationInfo'
import { Players } from './components/Players'

export const OrganizationSettings: React.FC = () => {
  const { user } = useUser()
  const navigate = useNavigate()

  const {
    addMembers,
    removeMember,
    isFetchingData,
    changeMemberRole,
    toggleMemberSaigeAccess,
    setAllMembersSaigeAccess,
    data,
  } = useBusinessSettings()
  const members = data?.members == null ? [] : data.members

  if (user == null || user.isSponsoredUser) {
    return null
  }

  const handleViewAllLicenseHolders = () => {
    navigate(routes.licenseHolderSettings)
  }

  const handleViewTags = () => {
    navigate(routes.playerAccountTagSettings)
  }

  if (data == null) return null

  return data == null && isFetchingData ? (
    <LoaderBlock />
  ) : (
    <div className={classNames(styles.sectionsContainer)}>
      <OrganizationInfo
        name={user.activeBusiness.name}
        membersCount={user.isBusinessAdmin ? data?.members?.length : undefined}
        licenceEndDate={dateTimeToLocalDateString(data?.businessInfo.validUntil, user.language)}
        maxMembersCount={data?.businessInfo.maxMembers || null}
        businessInfo={data?.businessInfo.newBusinessInfo || null}
        engineRounds={user.engineRounds}
        hasSaigeAccess={user.hasSaigeAccess}
        limitMembers={data?.businessInfo.limitMembers || false}
        orgHasSaigeAccess={!!data?.businessInfo.hasSaigeAccess}
        saigeAllMembers={!!data?.businessInfo.saigeAllMembers}
        onSetAllMembersSaigeAccess={setAllMembersSaigeAccess}
      />
      {user.isBusinessAdmin && (
        <Members
          members={members}
          maxMembers={data?.businessInfo.maxMembers || 1}
          limitMembers={data?.businessInfo.limitMembers}
          organizationName={user.activeBusiness.name}
          isLoading={isFetchingData}
          onRemoveMember={removeMember}
          onChangeMemberRole={changeMemberRole}
          onAddMembers={addMembers}
          orgHasSaigeAccess={!!data?.businessInfo.hasSaigeAccess}
          saigeAllMembers={!!data?.businessInfo.saigeAllMembers}
          onToggleMemberSaigeAccess={toggleMemberSaigeAccess}
        />
      )}
      {/* NOTE: commented out for now, to be revived once we define rules who can see players */}
      <Players
        businessInfo={data}
        organizationName={user.activeBusiness.name}
        onViewAllLicenseHolders={handleViewAllLicenseHolders}
        onViewTags={handleViewTags}
      />
    </div>
  )
}
